var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieInside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M16.44 12.5706C16.44 17.0906 12.76 20.7506 8.22 20.7506C3.68 20.7506 0 17.0856 0 12.5706C0 8.05563 3.68 4.39062 8.22 4.39062V12.5706H16.44Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M10.8797 8.07063C10.8797 7.42063 11.2497 6.86063 11.7847 6.57063C11.2497 6.28063 10.8797 5.72063 10.8797 5.07063C10.8797 4.99063 10.8947 4.92063 10.9047 4.84563C10.0647 4.55563 9.15973 4.39062 8.21973 4.39062V12.5706H16.4397C16.4397 11.5906 16.2597 10.6556 15.9397 9.78563H12.6047C11.6547 9.78563 10.8847 9.01563 10.8847 8.07063H10.8797Z",
    fill: "#AFB8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M17.8103 5.065C17.8103 5.52 17.4403 5.885 16.9853 5.885H12.6053C12.2003 5.885 11.8653 5.59 11.7953 5.21C11.7853 5.165 11.7803 5.115 11.7803 5.065C11.7803 4.615 12.1503 4.25 12.6053 4.25H16.9853C17.4403 4.25 17.8103 4.62 17.8103 5.065Z",
    fill: "#AFB8C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M20.0003 8.06988C20.0003 8.52488 19.6303 8.88488 19.1803 8.88488H12.6053C12.1503 8.88488 11.7803 8.51988 11.7803 8.06988C11.7803 7.61988 12.1503 7.25488 12.6053 7.25488H19.1803C19.6303 7.25488 20.0003 7.61988 20.0003 8.06988Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieInside);
export default __webpack_public_path__ + "static/media/pie-inside.4edea374d056c75e9ce2a0cb4f533beb.svg";
export { ForwardRef as ReactComponent };